
	/**
	 * @description
	 *	Nivel de severidad de una alerta.
	 */

export enum AlertSeverity {
	Error = "error",
	Information = "information",
	Success = "success",
	Warning = "warning"
}

export const toAlertSeverityString = (alertSeverity: AlertSeverity): string => {
	switch (alertSeverity) {
		case AlertSeverity.Error:
			return "Error";
		case AlertSeverity.Information:
			return "Información";
		case AlertSeverity.Success:
			return "Ok";
		case AlertSeverity.Warning:
			return "Atención";
		default:
			return "[Unknown AlertSeverity]";
	}
};
